import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("cp_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401 && localStorage.getItem("cp_token")) {
      localStorage.removeItem("cp_token");
      if (!window.location.pathname.includes("/login")) window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export async function pollJob(jobId, { interval = 2500, timeout = 300000 } = {}) {
  const start = Date.now();
  while (true) {
    const { data } = await api.get(`/jobs/${jobId}`);
    if (data.status === "done") return data.result;
    if (data.status === "error") throw new Error(data.error || "Job failed");
    if (Date.now() - start > timeout) throw new Error("This is taking longer than expected. Please try again.");
    await new Promise((r) => setTimeout(r, interval));
  }
}

export function apiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
